import { StandardLowerTierMessage } from '../../../../components/merch-card/features-display/StandardLowerTierMessage';
import { BrandingAndLimitPriorityFeatures } from './BrandingAndLimitPriorityFeatures';
import { UncategorizedPriorityFeatures } from './UncategorizedPriorityFeatures';
import { jsx as _jsx } from "react/jsx-runtime";
export const BrandingAndUncategorizedFeaturesDisplay = ({
  brandingAndLimitFeatures,
  uncategorizedFeatures,
  handleClick,
  isCollapsible = false,
  isFreePortal,
  productLevel,
  productLine
}) => {
  if (brandingAndLimitFeatures.length) {
    return /*#__PURE__*/_jsx(BrandingAndLimitPriorityFeatures, {
      brandingAndLimitFeatures: brandingAndLimitFeatures,
      uncategorizedFeatures: uncategorizedFeatures,
      handleClickFreeToolsWithLimitsLink: handleClick,
      isCollapsible: isCollapsible,
      isFreePortal: isFreePortal
    });
  }
  if (uncategorizedFeatures.length) {
    return /*#__PURE__*/_jsx(UncategorizedPriorityFeatures, {
      uncategorizedFeatures: uncategorizedFeatures,
      lowerTierMessage: /*#__PURE__*/_jsx(StandardLowerTierMessage, {
        productLevel: productLevel,
        productLine: productLine,
        handleClick: handleClick,
        isFreePortal: isFreePortal
      }),
      isCollapsible: isCollapsible
    });
  }
  return null;
};